import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiV2HreservationElCountParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiV2HreservationElCountParams, unknown>

const fetchHReservationCount = async (params: ApiV2HreservationElCountParams) => {
  const { data } = await apiClient.v2.apiV2HreservationElCount(params);
  return checkApiResponse(data);
}

export const v2HReservationCountKeys = {
  all: [QUERY_KEY.v2apiV2HreservationElCount] as const,
  list: (params: ApiV2HreservationElCountParams) => [...v2HReservationCountKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(v2HReservationCountQueryOptions(params))` */
export const v2HReservationCountQueryOptions = (params: ApiV2HreservationElCountParams) => ({
  queryKey: v2HReservationCountKeys.list(params),
  queryFn: () => fetchHReservationCount(params),
  // 날짜별 데이터 — FCM invalidation(타 사용자 변경)과 mutation invalidation(내 변경)이 커버하므로 5분 캐시
  staleTime: 5 * 60 * 1000,
  gcTime: 5 * 60 * 1000,
})

export const useV2HReservationCountQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: v2HReservationCountKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchHReservationCount(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
